import api from '../../../auth/apiClient';
import { BKM_MUAT_API_CONFIG } from '../apiConfig';
import { BkmMuatResponse, FilterValues } from '../types';

class BkmMuatApiService {
    /**
     * Fetch BKM Muat summary report data
     */
    async getBkmMuatReport(filters: FilterValues): Promise<BkmMuatResponse> {
        try {
            const postingDateFormatted = filters.current_date.replace(/-/g, '');
            const response = await api.get<BkmMuatResponse>(
                BKM_MUAT_API_CONFIG.endpoints.SUMMARY,
                {
                    params: {
                        posting_date: postingDateFormatted,
                        company_id: filters.company_id || 1,
                        estate_id: filters.estate_id,
                        division_id: filters.division_id,
                        report_type: 'summary',
                        activity_code: filters.activity_code
                    }
                }
            );
            return response.data;
        } catch (error: any) {
            console.error('Error fetching BKM Muat report:', error);
            throw error;
        }
    }
}

export default new BkmMuatApiService();
